import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const DigitalSignageHeader = ({ onAddLocation }) => {
  const { t } = useTranslation(['digital-signage'])
  return (
    <header className="digital-signage-header">
      <button className="add-new-location-btn" onClick={onAddLocation}>
        {t('digital-signage:header.addLocationButton')}
      </button>
    </header>
  )
}

DigitalSignageHeader.propTypes = {
  onAddLocation: PropTypes.func.isRequired,
}

export default DigitalSignageHeader
